import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-res-sales-details-by-year-dashboard',
    templateUrl: './res-sales-details-by-year-dashboard.component.html',
    styleUrls: ['./res-sales-details-by-year-dashboard.component.css'],
    standalone: false
})
export class ResSalesDetailsByYearDashboardComponent implements OnInit {

	@Input() showSearchUI = true;
	resRevByDay: any = [];
	groupDefaultExpanded: any;
	requestCount: any = 0;
	resRevByDayForDetailsSearch: any = [];
	resRevTotal: any = [];
	resRevMaster: any = [];
	dateValue: Date = new Date();

	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }


	// forms
	formLoading = false;
	columnApi: ColumnApi;

	// to hold the current search
	currentSearchForm: any;

	ngOnInit(): void {

	}

	onSearchSubmitYearForm(searchForm: any) {
		if(searchForm.saleYear) {
			const date: Date = searchForm.saleYear;
			var saleDateStart = new Date(date.getFullYear(), 0, 1);
			var saleDateEnd = new Date(date.getFullYear(), 11, 31);
			// var saleDateStart = new Date(date.getFullYear(), 2, 31);
			// var saleDateEnd = new Date(date.getFullYear(), 3, 30);
			searchForm.saleDateStart = saleDateStart;
			searchForm.saleDateEnd = saleDateEnd;
		}
		this.runReservationRevenueReport(searchForm, true);
	}

	runReservationRevenueReport(searchForm, isDetailsSearch:boolean) {
		try {
			this.formLoading = true;
			console.log('Request data', searchForm);
			this.reportService.reservationRevenueReport(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));
						if(isDetailsSearch) {
							this.resRevByDayForDetailsSearch = res.data.resRevenues.resRevByDay;
						} else {
							this.resRevByDay = res.data.resRevenues.resRevByDay;
							this.resRevTotal = res.data.resRevenues.resRevTotal;
							this.resRevMaster = res.data.resRevenues.resRevMaster;
						}
						this.requestCount = this.requestCount + 1;
						//Show default open all groups first time only
						// if(this.requestCount > 2) {
						// 	this.groupDefaultExpanded = 0;
						// } 
						// else {
						// 	this.groupDefaultExpanded = -1;
						// }
						//Uncomment above conditiona and comment below line if wanted to show expanded groups for first time
						this.groupDefaultExpanded = 0;
						this.columnApi.autoSizeAllColumns();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	ngAfterViewInit(): void {
	}

}
